import $, { get } from 'jquery'
import {validate} from 'jquery-validation'
import {lazySizes} from 'lazysizes'
import active from './util/active'
import accordion from './util/accordion'
import smoothScroll from './util/smoothScroll'
import customize from './util/customize'
import tabChange from './util/tabChange'
import date from './util/date'
import {headerFixed, toTop, footerShow} from './util/scrollEvent'
import {formValid, formReset, enterDisallow, errorJump, submitCheck} from './util/formValid'

// lazySizes
lazySizesConfig = lazySizesConfig || {};
lazySizesConfig.lazyClass = 'lazy';
lazySizesConfig.srcAttr = 'data-src';
lazySizesConfig.loadMode = 2;

$(() => {
	active();
	accordion();
	smoothScroll();
	customize();
	formValid();
	formReset();
	enterDisallow();
	errorJump();
	submitCheck();
	var urlPath = location.pathname ;
	if( urlPath == '/' || urlPath == '/index.php' || urlPath == '/index') { 
		date();	
	}else if( urlPath == '/mail.php' ){
		$('.c-form__item').eq(0).css('display','none')
	}
	// headerFixed();
	toTop();
	footerShow();
});

var selectColor = function() {
	// 現在選択されてる項目によって色設定
	var select = $('[data-target-select]');

	if(select.find('option:selected').hasClass('disabled-color')) {
		$('select').css({'color': '#959595'});
	}
	// 項目が変更された時、条件によって色変更
	select.on('change', function(){
		if($(this).find('option:selected').hasClass('disabled-color')) {
			$(this).css({'color': '#959595'});
		} else {
			$(this).css({'color': '#434343'});
		}
	});
};
$(function(){
	selectColor();
});


// WEBPACK FOOTER //
// ./src/js/app.js